// src/components/AppliMobileForm.js
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import '../styles/CGU.css';

const AppliMobileForm = () => {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    message: '',
    platform: 'android' // Valeur par défaut
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Pour les radios, on utilise simplement value
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Préparer les paramètres pour le template EmailJS
    const templateParams = {
      nom: formData.nom,
      email: formData.email,
      telephone: formData.telephone,
      message: formData.message,
      plateforme: formData.platform,
      timestamp: new Date().toISOString()
    };

     emailjs.send("service_lqqcwv6","template_h620kdd", templateParams, 'Zrkdw-wjCsct923Qy')
      .then((result) => {
         toast.success("Inscription à la liste d'attente réussie", {
                position: "top-right",
                autoClose: 3000, // Disparition après 3 secondes
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });
      }, (error) => {
          console.error('Erreur lors de l\'envoi du formulaire :', error.text);
          alert("Erreur lors de l'envoi du formulaire. Veuillez vérifier que tous les champs obligatoires sont remplis.");
      });

    // Réinitialiser le formulaire
    setFormData({
      nom: '',
      email: '',
      telephone: '',
      message: '',
      platform: 'android'
    });
  };

  return (
    <form onSubmit={handleSubmit} className="newsletter-form">
      <div className="form-group">
        <label htmlFor="nom">Nom</label>
        <input
          type="text"
          id="nom"
          name="nom"
          value={formData.nom}
          onChange={handleChange}
          placeholder="Votre nom"
        />
      </div>
      <div className="form-group">
        <label htmlFor="email">Adresse e-mail</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          placeholder="✉️ Votre email"
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label>Plateforme :</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="platform"
              value="android"
              checked={formData.platform === 'android'}
              onChange={handleChange}
              required
            />
            Android
          </label>
          <label>
            <input
              type="radio"
              name="platform"
              value="ios"
              checked={formData.platform === 'ios'}
              onChange={handleChange}
              required
            />
            iOS
          </label>
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="telephone">Téléphone</label>
        <input
          type="tel"
          id="telephone"
          name="telephone"
          value={formData.telephone}
          placeholder="📞 Votre numéro de téléphone"
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="message">Votre Raison</label>
        <textarea
          id="message"
          name="message"
          className="border p-2 rounded resize-none"
          value={formData.message}
          onChange={handleChange}
          rows="5"
          placeholder="Expliquez votre raison ici..."
          required
        ></textarea>
      </div>

      <button type="submit" className="submit-button">
        Envoyer 🚀
      </button>
    </form>
  );
};

export default AppliMobileForm;
